import React from 'react';
import { Card, CardContent, LinearProgress, Step, StepLabel, Stepper, Typography } from '@mui/material';

interface ActivityProgressCardProps {
  progressRef: React.RefObject<HTMLDivElement>;
  generatingStep: number;
  steps: string[];
}

const ActivityProgressCard: React.FC<ActivityProgressCardProps> = ({ progressRef, generatingStep, steps }) => (
  <Card ref={progressRef}>
    <CardContent>
      <Typography variant='h6' gutterBottom color='text.secondary'>
        Generating...
      </Typography>
      <Stepper activeStep={generatingStep} sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <LinearProgress />
    </CardContent>
  </Card>
);

export default ActivityProgressCard;
